import { useContext } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useHMSStore, selectLocalPeer } from "@100mslive/react-sdk";

import logo from "../../assets/images/logo.svg";
import { Button } from "../../components/workshop";
import { CallControl } from "../../components/videoCalling";

const RemoteLayout = ({
  children,
  buttonText,
  buttonColor,
  onButtonClick,
  onBackClick,
  hideCallControl = false
}) => {
  const { t } = useTranslation();
  const localPeer = useHMSStore(selectLocalPeer);
  const hasButtons = onBackClick || (buttonText && onButtonClick);

  return (
    <div className="min-h-screen p-8 flex flex-col bg-gray-250 text-white">
      <div className="absolute top-4 left-4">
        <img src={logo} alt="Logo" className="w-12 h-12" />
      </div>
      <div className="mt-10 max-w-5xl container mx-auto flex-1">{children}</div>

      {/* Navigation buttons - above the separator */}
      

      {/* Footer with separator and call controls */}
      <footer className="max-w-6xl w-full mx-auto ">
        <div
          className={`flex items-center px-2 sm:px-4 py-3 sm:py-4 bg-gray-250/95 backdrop-blur-md rounded-t-2xl border-t border-white-200/30 flex-col ${
            hasButtons ? "md:flex-row-reverse md:justify-between" : "md:flex-row md:justify-start"
          } justify-center`}>
          {hasButtons && (
            <div className="w-fit py-4 md:my-0">
              <div className="gap-x-4 flex items-center">
                {onBackClick && (
                  <div className="max-w-fit">
                    <Button
                      type="rounded"
                      className={"!bg-green-50 !text-green-500 border-green-500 border-2"}
                      onClick={onBackClick}>
                      ←{t("button.back")}
                    </Button>
                  </div>
                )}
                {buttonText && onButtonClick && (
                  <div className="max-w-fit">
                    <Button
                      type="rounded"
                      className={buttonColor === "orange" ? "" : "!bg-green-500"}
                      onClick={onButtonClick}>
                      {buttonText}
                    </Button>
                  </div>
                )}
              </div>
            </div>
          )}
          {localPeer && !hideCallControl && (
            <div className="flex items-center justify-start">
            <CallControl containerClass="!relative !bottom-0 !left-0 !translate-x-0 mx-auto sm:mx-0" />
            </div>
          )}
        </div>
      </footer>
    </div>
  );
};
RemoteLayout.defaultProps = {
  buttonColor: "green"
};

RemoteLayout.propTypes = {
  buttonText: PropTypes.string,
  buttonColor: PropTypes.oneOf(["green", "orange"]),
  onButtonClick: PropTypes.func,
  showParticipants: PropTypes.bool
};

export default RemoteLayout;
